import { render, staticRenderFns } from "./PersonalTraining.vue?vue&type=template&id=39bed339&scoped=true"
import script from "./PersonalTraining.vue?vue&type=script&lang=js"
export * from "./PersonalTraining.vue?vue&type=script&lang=js"
import style0 from "./PersonalTraining.vue?vue&type=style&index=0&id=39bed339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bed339",
  null
  
)

export default component.exports